import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import Pages from "./Pages";
import TypePageConstant from "./TypePageConstant";
import StatePageConstant from "./StatePageConstant";
import helperNumber from "../../../helpers/numbers";
import helperTime from "../../../helpers/time";

export default function AllPage() {
  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="صفحات سایت batmatic-test.ir" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="d-flex flex-column-reverse flex-sm-row justify-content-sm-between">
                <div className="pt-2 pt-sm-0">
                  <Link to="/page/add/publisher/1" className="btn btn-success">
                    <span className="pl-2">
                      <i className="fa fa-plus"> </i>
                    </span>
                    <span>اضافه صفحه کردن به سایت نمایش دهنده</span>
                  </Link>
                </div>
                <div className="text-left">
                  <Link className="btn btn-primary" to="/publisher/all">
                    <span>بازگشت</span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left"></i>
                    </span>
                  </Link>
                </div>
              </div>
              <div className="table-responsive pt-2">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره</td>
                      <td>عنوان </td>
                      <td>الگوی آدرس</td>
                      <td>لینک</td>
                      <td>وضعیت</td>
                      <td>حالت</td>
                      <td>تاریخ درج</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                    {Pages.map((page, index) => {
                      let doseShowPositions;
                      let classBadgeStatePage;
                      switch (page.state) {
                        case StatePageConstant.statusSiteUserPublisher.PENDING:
                          doseShowPositions = false;
                          classBadgeStatePage = "badge-warning";
                          break;
                        case StatePageConstant.statusSiteUserPublisher.CONFIRM:
                          doseShowPositions = true;
                          classBadgeStatePage = "badge-info";
                          break;
                        case StatePageConstant.statusSiteUserPublisher.REJECT:
                          doseShowPositions = false;
                          classBadgeStatePage = "badge-danger";
                          break;
                        case StatePageConstant.statusSiteUserPublisher
                          .REJECT_EDIT:
                          doseShowPositions = true;
                          classBadgeStatePage = "badge-danger";
                          break;
                        case StatePageConstant.statusSiteUserPublisher
                          .PENDING_EDIT:
                          doseShowPositions = true;
                          classBadgeStatePage = "badge-warning";
                          break;
                      }

                      return (
                        <tr>
                          <td>{helperNumber.toPersianNum(index + 1)}</td>
                          <td>{helperNumber.toPersianNum(page.ID)}</td>
                          <td>
                            {page.title}
                            {page.pattern.includes("/@s") ? (
                              <span className="pr-2">
                                <span className="badge badge-success">
                                  {
                                    TypePageConstant.typePageString()[
                                      TypePageConstant.typePage.MULTI_PAGE
                                    ]
                                  }
                                </span>
                              </span>
                            ) : (
                              <span className="pr-2">
                                <span className="badge badge-warning">
                                  {
                                    TypePageConstant.typePageString()[
                                      TypePageConstant.typePage.STATIC
                                    ]
                                  }
                                </span>
                              </span>
                            )}
                          </td>
                          <td>
                            <div dir="ltr" className="text-left">
                              {page.pattern}
                            </div>
                          </td>
                          <td>
                            <a
                              href={page.link}
                              target="_blank"
                              className="btn btn-info"
                            >
                              <i className="fa fa-link"></i>
                            </a>
                          </td>
                          <td>
                            <span className={`badge ${classBadgeStatePage}`}>
                              {page.state}
                            </span>
                          </td>
                          <td>
                            <div dir="ltr" className="text-center">
                              {page.active ? (
                                <span className="badge badge-success">
                                  فعال
                                </span>
                              ) : (
                                <span className="badge badge-danger">
                                  غیر فعال
                                </span>
                              )}
                            </div>
                          </td>
                          <td>{page.created_at}</td>
                          <td>
                            {doseShowPositions && (
                              <span className="pl-2">
                                <Link
                                  to={`/positions/all/page/${page.ID}`}
                                  className="btn btn-info"
                                >
                                  نمایش جایگاه ها تبلیغاتی
                                </Link>
                              </span>
                            )}
                            <span className="pl-2">
                              <Link
                                to={`/page/view/${page.ID}`}
                                className="btn btn-info"
                              >
                                <i className="fa fa-info"></i>
                              </Link>
                            </span>
                            <span>
                              <Link
                                to={`/page/edit/${page.ID}`}
                                className="btn btn-success"
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
